<template>
  <div id="chargingRateSetting" class="chargingRateSetting" v-loading.fullscreen.lock="pageLoading">
    <div class="main">
      <!-- Title -->
      <div class="title_bar">
        <div class="left">
          <div class="title">
            <div>{{ $t('EvCharging.ParkingRateSetting') }}</div>
          </div>
        </div>
        <div class="right">
          <span class="tip">{{ $t('EvCharging.RequiredTip') }}</span>
        </div>
      </div>
      <div class="content">
        <div class="data-set-item status-choose">
          <div class="title">
            <span class="tip">*</span>{{ $t('EvCharging.StatusChoose') }}
          </div>
          <div>
            <el-radio-group v-model="statusChoose">
              <el-radio key="notUse" label="notUse">
                <span>{{ $t('EvCharging.NotUse') }}</span>
              </el-radio>
              <el-radio key="use" label="use">
                <span>{{ $t('EvCharging.Use') }}</span>
              </el-radio>
            </el-radio-group>
          </div>
        </div>
        <template v-if="statusChoose === 'use'">
          <div class="data-set-item input-setting">
            <div class="title">
              <span class="tip">*</span>{{ $t('EvCharging.BufferTime') }}
            </div>
            <div class="input-content">
              <el-input-number
                v-model="bufferMinutes"
                :precision="0"
                :controls="false"
                :placeholder="$t('EvCharging.MinutesPlaceholder')"
              />
              <span class="unit">{{ $t('EvCharging.Minutes') }}</span>
            </div>
          </div>
          <div class="data-set-item input-setting">
            <div class="title">
              <span class="tip">*</span>{{ $t('EvCharging.PriceUnit') }}
            </div>
            <div class="input-content">
              <el-input-number
                v-model="priceUnitMinutes"
                :precision="0"
                :controls="false"
                :placeholder="$t('EvCharging.MinutesPlaceholder')"
              />
              <span class="unit">{{ $t('EvCharging.MinutesPrice') }}</span>
            </div>
          </div>
          <div class="data-set-item input-setting">
            <div class="title">
              <span class="tip">*</span>{{ $t('EvCharging.ParkingPrice') }}
            </div>
            <div class="input-content">
              <el-input-number
                v-model="pricePerUnit"
                :precision="0"
                :controls="false"
                :placeholder="$t('EvCharging.PricePlaceholder')"
              />
              <span class="unit">{{ $t('EvCharging.Dollar') }}</span>
            </div>
          </div>
          <div class="data-set-item input-setting">
            <div class="title" />
            <div class="example">
              <div>
                {{ $t('EvCharging.Example1') }}
              </div>
              <div>
                {{ $t('EvCharging.Example2') }}
              </div>
            </div>
          </div>
        </template>
      </div>
      <div class="footer">
        <el-button
          @click="goBack"
          round
        >
          {{ $t('General.Cancel') }}
        </el-button>
        <el-button
          @click="confirm"
          round
          type="primary"
        >
          {{ $t('General.Confirm') }}
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { apiEvCharging } from '@/api/EvCharging'
export default {
  data () {
    return {
      pageLoading: true,
      statusChoose: 'notUse',
      bufferMinutes: null,
      priceUnitMinutes: null,
      pricePerUnit: null,
      originSettingData: {}
    }
  },
  async created () {
    await this.getRateSetting()
  },
  methods: {
    goBack () {
      this.$router.push({ name: 'rateSetting' })
    },
    async getRateSetting () {
      this.pageLoading = true
      apiEvCharging.RateSetting.getRateSetting().then(res => {
        if (res?.data?.Data?.Pricing) {
          this.originSettingData = _cloneDeep(res.data.Data)
          if (res.data.Data.Pricing.IdlePrice) {
            this.statusChoose = res.data.Data.Pricing.IdlePrice.Enabled ? 'use' : 'notUse'
            this.bufferMinutes = res.data.Data.Pricing.IdlePrice.IdleBufferMinutes
            this.priceUnitMinutes = res.data.Data.Pricing.IdlePrice.IdlePriceUnitMinutes
            this.pricePerUnit = res.data.Data.Pricing.IdlePrice.IdlePricePerUnit
          }
        }
        this.pageLoading = false
      }).catch(err => {
        console.log(err)
        this.pageLoading = false
      })
    },
    dataIsEmpty () {
      if (this.statusChoose === 'use') {
        if (!this.bufferMinutes) return true
        if (!this.priceUnitMinutes) return true
        if (!this.pricePerUnit) return true
      }
      return false
    },
    dataIsZero () {
      if (this.statusChoose === 'use') {
        if (this.priceUnitMinutes === 0) return true
        if (this.pricePerUnit === 0) return true
      }
      return false
    },
    confirm () {
      if (this.dataIsEmpty()) {
        this.$message.error(this.$t('EvCharging.RequiredCantEmpty'))
        return
      }
      if (this.dataIsZero()) {
        this.$message.error(this.$t('EvCharging.PriceAndMinuteCantZero'))
        return
      }
      const requestData = this.getUpdateRequestData()
      apiEvCharging.RateSetting.patchRateSetting(requestData).then(res => {
        if (!res.data.Data) this.goBack()
        else throw new Error(res.data.Data.errors)
      }).catch(e => {
        this.$message.error(this.$t('EvCharging.ParkingRateSettingFail'))
        console.log(e)
      })
    },
    getUpdateRequestData () {
      const updateData = _cloneDeep(this.originSettingData)
      if (!updateData.Pricing.IdlePrice) updateData.Pricing.IdlePrice = {}
      updateData.Pricing.IdlePrice.Enabled = this.statusChoose === 'use'
      if (updateData.Pricing.IdlePrice.Enabled) {
        updateData.Pricing.IdlePrice.IdlePricePerUnit = this.pricePerUnit
        updateData.Pricing.IdlePrice.IdlePriceUnitMinutes = this.priceUnitMinutes
        updateData.Pricing.IdlePrice.IdleBufferMinutes = this.bufferMinutes
      } else {
        delete updateData.Pricing.IdlePrice.IdlePricePerUnit
        delete updateData.Pricing.IdlePrice.IdlePriceUnitMinutes
        delete updateData.Pricing.IdlePrice.IdleBufferMinutes
      }
      const requestData = {
        Changes: updateData
      }
      return requestData
    }
  }
}
</script>

<style lang="scss" scoped>
.chargingRateSetting {
  @include mainLayer();
  .title_bar {
    .right {
      .tip {
        color: $dangerColor !important;
      }
    }
  }
  .content {
    padding: 48px 32px;
    text-align: left;
    .data-set-item {
      display: flex;
      justify-content: left;
      margin-bottom: 20px;
      &.status-choose,
      &.input-setting,
      &.time-setting {
        align-items: center;
      }
      &.input-setting {
        .input-content {
          display: flex;
          align-items: center;
          justify-content: left;
          gap: 8px;
        }
      }
      .title {
        width: 130px;
        min-width: 70px;
        text-align: right;
        margin-right: 16px;
        font-size: map-get($fontSize, small);
        font-weight: 600;
        color: $mainFontColor;
        .tip {
          color: $dangerColor;
        }
      }
      .table-content {
        width: 100%;
        .time-range-display {
          display: flex;
          width: 100%;
          border: 1px solid $borderDark1;
          border-radius: 8px;
          .day {
            flex: 1;
            .table-title {
              background-color: $bgGrayGreen;
              border-bottom: 1px solid $borderDark1;
            }
            .content {
              padding: 8px;
              .time-range {
                padding: 4px 0;
              }
            }
            >div {
              min-height: 50px;
              padding: 0px;
              display: flex;
              justify-content: center;
              align-items: center;
            }
            &:not(:last-child) {
              border-right: 1px solid $borderDark1;
            }
            &:first-child {
              .title {
                border-radius: 8px 0 0 0;
              }
            }
            &:last-child {
              .title {
                border-radius: 0 8px 0 0;
              }
            }
          }
        }
      }
      .unit {
        font-size: map-get($fontSize, x-small);
        color: $mainFontColor;
        white-space: nowrap;
      }
      .example {
        padding: 10px 16px;
        color: $mainFontColor;
        font-size: map-get($fontSize, small);
        line-height: 1.3pc;
        background-color: $bgDark3;
      }
    }
  }
  ::v-deep .el-input-number {
    input {
      text-align: left;
    }
  }
}
</style>
